import { strCode } from "../localizations/strCode";

export const channelIds = {
  consumer: "consumer",
  coach: "coach"
};

export const channelOptions = [
  { id: channelIds.consumer, value: strCode.CONSUMER_CHANNEL },
  { id: channelIds.coach, value: strCode.COACH_CHANNEL }
];
